<div class="mb-4">
  <span class="fw-bold"> Type d'affichage : </span>
  <span>
    {{ references.isDisplayModeDetailled ? "Liste détaillée" : "Liste simple" }}
  </span>
</div>

<div class="mb-4">
  <span class="fw-bold"> Confidentialité des données : </span>
  <span>
    {{ !references.isConfidential ? "Exemplaire office" : "Exemplaire client" }}
  </span>
</div>

<div *ngIf="reportType !== 'automatic_evaluation'" class="mb-4">
  <span class="fw-bold"> Références à afficher : </span>
  <span>
    {{
      !references.isSelection
        ? "Toutes les références achetées (" + references.purchasedCount + ")"
        : "Références sélectionnées (" + references.selectedCount + ")"
    }}
  </span>
</div>
